/* ทะเบียนเมนูของระบบ — ต้องตรงกับ api/common/menu.php
   key  : รหัสเมนูที่ใช้เก็บสิทธิ์
   to   : path ของหน้า (ตรงกับ src/nav.js และ src/route/*)  */
export const MENUS = [
  { key: "support_project",          title: "โปรเจ็กต์บ้าน",       group: "Support", to: "/support/project",          actions: ["view", "add", "edit", "delete"] },
  { key: "support_selection",        title: "ใบเลือกวัสดุ",         group: "Support", to: "/support/selection",        actions: ["view", "add", "edit", "delete"] },
  { key: "support_rc",               title: "RC (ลูกค้าแจ้งเปลี่ยนแปลง)", group: "Support", to: "/support/rc",            actions: ["view", "add", "edit"] },
  { key: "support_customer",         title: "ข้อมูลลูกค้า",         group: "Support", to: "/support/customer",         actions: ["view", "add", "edit", "delete"] },

  { key: "master_house_model",       title: "แบบบ้าน",            group: "Master",  to: "/master/house-model",       actions: ["view", "add", "edit", "delete"] },
  { key: "master_material",          title: "วัสดุ",               group: "Master",  to: "/master/material",          actions: ["view", "add", "edit", "delete"] },
  { key: "master_material_category", title: "หมวดวัสดุ",           group: "Master",  to: "/master/material-category", actions: ["view", "add", "edit", "delete"] },
  { key: "master_employee",          title: "พนักงาน",             group: "Master",  to: "/master/employee",          actions: ["view", "add", "edit", "delete"] },
  { key: "master_template",          title: "Template เลือกวัสดุ",  group: "Master",  to: "/master/template",          actions: ["view", "add", "edit", "delete"] },

  { key: "user",                     title: "ผู้ใช้งาน",            group: "Admin",   to: "/user",                     actions: ["view", "add", "edit", "delete"] },
  { key: "permission",               title: "สิทธิ์การเข้าถึง",      group: "Admin",   to: "/permission",               actions: ["view", "edit"] },
];

export const ACTION_LABEL = {
  view: "เข้าดู",
  add: "เพิ่ม",
  edit: "แก้ไข",
  delete: "ลบ / ยกเลิก",
};

export const menuByKey = (key) => MENUS.find((m) => m.key === key);

/* หา key ของเมนูจาก path ปัจจุบัน — เลือกอันที่ match ยาวที่สุด */
export const menuKeyByPath = (pathname = "") => {
  const matched = MENUS.filter((m) => pathname.startsWith(m.to)).sort(
    (a, b) => b.to.length - a.to.length
  )[0];
  return matched?.key;
};

export default MENUS;
